import React from 'react';

const organizationName = process.env.REACT_APP_ORGANIZATION_NAME;

const Details = ({ formData }) => {
  const refresh = () => window.location.reload(true);

  return (
    <div className="">
      <form id="myForm" style={{ marginTop: '10%' }}>
        <div className="container">
          <img
            className="leftimg"
            alt="RequestHQ_logo"
            src="/Agendis_Request1.png"
            style={{ height: '25px' }}
          />
        </div>
        <div className="line"></div>

        <h1 style={{ marginTop: '25px' }}>
          Thank you for submitting your request!
        </h1>
        <p style={{ paddingTop: '2%', fontSize: '16px' }}>
          A confirmation email containing the details of your request will be
          sent to the email address you provided.
        </p>
        <p style={{ fontSize: '16px' }}>
          Please check your inbox, including the spam folder, to ensure that you
          receive the email.
        </p>

        <span
          style={{
            marginBlockEnd: '0.25em',
            fontSize: '16px',
            marginTop: '20px',
          }}
        >
          Best regards,
        </span>
        <span style={{ marginBlockEnd: '0.5em', fontSize: '16px' }}>
          {organizationName}
        </span>
        <div className="button-container">
          <div>
            <button type="button" id="submitButtonHome" onClick={refresh}>
              Home
            </button>
          </div>
        </div>
        <div className="logos-container" style={{ paddingTop: '10%' }}>
          <img
            className="logo-img"
            alt="Cohesis Logo"
            src="/Cohesis_logo.svg"
          />
        </div>
      </form>
    </div>
  );
};

export default Details;
